<template>
    <v-dialog v-model="dialog" max-width="800" persistent>
        <v-card>
            <v-card-title class="primary white--text title">
                {{ 'Config'|translate }}
            </v-card-title>
            <v-card-text>
                <v-text-field :label="'Config Name'|translate" autofocus
                              v-model="activeItem.config_name"></v-text-field>
                <v-text-field :label="'Facility Name'|translate" autofocus v-model="activeItem.facility_name"
                              disabled></v-text-field>
                <editor v-model="activeItem.config" @init="editorInit" lang="json" theme="twilight" width="100%"
                        height="500"></editor>

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="addRecord" :disabled="!$can('update', 'Config')">{{ 'Save'|translate }}
                </v-btn>
                <v-btn @click="initializeVar(true)">{{ 'Cancel'|translate }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {putConfig} from '../../helper'
import editor from 'vue2-ace-editor'

export default {
    components: {editor},
    props: {
        value: {type: Boolean, default: true},
        item: {type: Object, default: null}
    },
    watch: {
        item(item) {
            this.initializeVar()
            if (item) {
                this.activeItem = this.item
            }
        },
        value() {
            if (!this.activeItem.config_id) {
                this.initializeVar()
            }
            if (this.dialog != this.value) {
                this.dialog = this.value
            }
        },
        dialog() {
            this.$emit('input', this.dialog)
        }
    },
    data() {
        return {
            dialog: false,
            activeItem: {
                config_id: null,
                config_name: '',
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                config: '',

            },

        }
    },
    methods: {
        editorInit: function () {
            require('brace/ext/language_tools')
            require('brace/mode/json')
            require('brace/theme/twilight')
        },
        initializeVar(close) {
            this.activeItem = {
                config_id: null,
                config_name: '',
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                config: '',

            }
            if (close) {
                this.dialog = false;
            }
        },
        addRecord() {
            putConfig(
                {
                    'config_id': this.activeItem.config_id,
                    'config_name': this.activeItem.config_name,
                    'facility_name': this.activeItem.facility_name,
                    'config': this.activeItem.config,

                }
            )
            this.dialog = false;
            this.$emit('doreload')
        }
    },
    name: 'ConfigRecordDialog'
}
</script>

<style scoped>

</style>
